import React, { useState, useContext } from "react"
import Axios from "axios"
import DispatchContext from "../DispatchContext"

function HeaderLoggedOut(props) {
  const appDispatch = useContext(DispatchContext)
  const [username, setUsername] = useState()
  const [password, setPassword] = useState()

  async function handleSubmit(e) {
    const ourRequest = Axios.CancelToken.source()
    e.preventDefault()
    try {
      const response = await Axios.post("/users/login", { email: username, password }, { cancelToken: ourRequest.token })
      if (response.data) {
        console.log(response.data.user)
        // localStorage.setItem("keeperAppToken", response.data.token)
        // localStorage.setItem("keeperAppUsername", response.data.user.email)

        // props.setLoggedIn(true)
        // appDispatch({ type: "login" })
        appDispatch({ type: "login", data: response.data })
        //flashmessages
        // props.addFlashMessage("Successfully! logged in.")
        appDispatch({ type: "flashMessage", value: "You are successfully loggedIn!" })
      } else {
        console.log("Incorrect/password!")
      }
    } catch (e) {
      appDispatch({ type: "flashMessage", value: "Invalid username/password!" })
      console.log(e)
      console.log("There was a problem.")
    }
  }

  return (
    <form onSubmit={handleSubmit} className="mb-0 pt-2 pt-md-0">
      <div style={{ margin: " auto -16px", padding: "16px 32px", position: "absolute", top: 20, right: 0 }} className="row align-items-center">
        <div className="col-md mr-0 pr-md-0 mb-3 mb-md-0">
          <input onChange={e => setUsername(e.target.value)} name="username" className="form-control form-control-sm input-dark" type="text" placeholder="Username" autoComplete="off" />
        </div>
        <div className="col-md mr-0 pr-md-0 mb-3 mb-md-0">
          <input onChange={e => setPassword(e.target.value)} name="password" className="form-control form-control-sm input-dark" type="password" placeholder="Password" />
        </div>
        <div className="col-md-auto">
          <button className="btn btn-outline-dark btn-sm">Sign In</button>
        </div>
      </div>
    </form>
  )
}

export default HeaderLoggedOut
